import React from 'react';
import './App.css'
import ApplicationForm from './Components/ApplicationForm/ApplicationForm';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AdminShowData from './Components/Admin/AdminShowData/AdminShowData';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import Register from './Components/Admin/Register/Register';
import Login from './Components/Admin/Login/Login';
import ProtectedRoute from './Components/Admin/ProtectedRoutes/ProtectedRoute'
import CreateTreck from './Components/Admin/CreateTreck/CreateTreck';
import ManageLinks from './Components/Admin/ManageLinks/ManageLinks';
import RedirectShortLink from './Components/RedirectShortLink/RedirectShortLink';

const App = () => {
  return (
    <div className='mainApp'>
      <BrowserRouter>
        <Navbar />

        <Routes>
          {/* <Route path='/' element={<Home />} /> */}
          <Route path='/' element={<ApplicationForm />} />
          <Route path='/s/:code' element={<RedirectShortLink />} />
          <Route path='/register' element={
             <ProtectedRoute>
              <Register />
            </ProtectedRoute>
          } />
          <Route path='/login' element={<Login/>} />
           <Route path="/applicationFormData" element={
            <ProtectedRoute>
              <AdminShowData />
            </ProtectedRoute>
          }
        />

         <Route path="/createtreck" element={
            <ProtectedRoute>
              <CreateTreck />
            </ProtectedRoute>
          }
        />

         <Route path="/links" element={
            <ProtectedRoute>
              <ManageLinks />
            </ProtectedRoute>
          }
        />
          {/* <Route path='/applicationFormData' element={<AdminShowData />} /> */}
        </Routes>

        {/* <Footer /> */}
      </BrowserRouter>
    </div>
  );
};

export default App;
